import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import { ACTIONS } from './actions';
import { PERMISSIONS } from './permissions';
import { SUBJECTS } from './subjects';

const PERMISSION_RULES = {
  [PERMISSIONS.CAN_VIEW_STATISTICS]: (can) => {
    can(ACTIONS.READ, SUBJECTS.STATISTICS);
  },
  [PERMISSIONS.CAN_ACCESS_WEB_USERS]: (can) => {
    can(ACTIONS.ACCESS, SUBJECTS.WEB_USERS);
    can(ACTIONS.READ, SUBJECTS.WEB_USERS);
  },
  [PERMISSIONS.CAN_MANAGE_WEB_ACCESS]: (can) => {
    can(ACTIONS.ACCESS, SUBJECTS.WEB_USERS);
    can(ACTIONS.CREATE, SUBJECTS.WEB_USERS);
    can(ACTIONS.UPDATE, SUBJECTS.WEB_USERS);
    can(ACTIONS.DELETE, SUBJECTS.WEB_USERS);
  },
  [PERMISSIONS.CAN_ACCESS_CONFIGURATIONS]: (can) => {
    can(ACTIONS.ACCESS, SUBJECTS.CONFIGURATION);
  },
  [PERMISSIONS.CAN_CREATE_DRIVES]: (can) => {
    can(ACTIONS.CREATE, SUBJECTS.DRIVE);
  },
  [PERMISSIONS.CAN_ACCESS_DRIVERS]: (can) => {
    can(ACTIONS.ACCESS, SUBJECTS.DRIVER);
    can(ACTIONS.READ, SUBJECTS.DRIVER);
  },
  [PERMISSIONS.CAN_DELETE_DRIVERS]: (can) => {
    can(ACTIONS.DELETE, SUBJECTS.DRIVER);
    can(ACTIONS.READ, SUBJECTS.DRIVER);
  },
  [PERMISSIONS.CAN_DEACTIVATE_DRIVER_ACCOUNT]: (can) => {
    can(ACTIONS.ACCESS, SUBJECTS.DRIVER_ACCOUNT);
  },
  [PERMISSIONS.CAN_EDIT_DRIVERS]: (can) => {
    can(ACTIONS.CREATE, SUBJECTS.DRIVER);
    can(ACTIONS.UPDATE, SUBJECTS.DRIVER);
    can(ACTIONS.READ, SUBJECTS.DRIVER);
  },
  [PERMISSIONS.CAN_ACCESS_CARS]: (can) => {
    can(ACTIONS.ACCESS, SUBJECTS.CAR);
    can(ACTIONS.READ, SUBJECTS.CAR);
  },
  [PERMISSIONS.CAN_DELETE_CARS]: (can) => {
    can(ACTIONS.DELETE, SUBJECTS.CAR);
    can(ACTIONS.READ, SUBJECTS.CAR);
  },
  [PERMISSIONS.CAN_EDIT_CARS]: (can) => {
    can(ACTIONS.CREATE, SUBJECTS.CAR);
    can(ACTIONS.UPDATE, SUBJECTS.CAR);
    can(ACTIONS.READ, SUBJECTS.CAR);
  },
  [PERMISSIONS.CAN_DELETE_STANDS]: (can) => {
    can(ACTIONS.DELETE, SUBJECTS.STAND);
    can(ACTIONS.READ, SUBJECTS.STAND);
  },
  [PERMISSIONS.CAN_EDIT_STANDS]: (can) => {
    can(ACTIONS.CREATE, SUBJECTS.STAND);
    can(ACTIONS.UPDATE, SUBJECTS.STAND);
    can(ACTIONS.READ, SUBJECTS.STAND);
  },
  [PERMISSIONS.CAN_MANAGE_ADS]: (can) => {
    can(ACTIONS.ACCESS, SUBJECTS.AD);
    can(ACTIONS.READ, SUBJECTS.AD);
    can(ACTIONS.CREATE, SUBJECTS.AD);
    can(ACTIONS.UPDATE, SUBJECTS.AD);
    can(ACTIONS.DELETE, SUBJECTS.AD);
  },
};

/**
 * Builds a CASL ability from DB permission names for the logged-in user.
 */
export const defineAbilityFor = (permissionNames = []) => {
  const { can, build } = new AbilityBuilder(createMongoAbility);

  const granted = new Set(permissionNames);
  Object.entries(PERMISSION_RULES).forEach(([permission, applyRule]) => {
    if (granted.has(permission)) {
      applyRule(can);
    }
  });

  return build();
};

/** Deny-all ability for logged-out sessions */
export const createEmptyAbility = () => {
  const { build } = new AbilityBuilder(createMongoAbility);
  return build();
};
